export enum ApiControllerActionEnum {
  GetLanguages='Localization/getLanguages',
  VehicleReservationGetReturnLocations = 'VehicleReservationCase/GetReturnLocations',
  VehicleReservationGetOneWayRentalReturnLocations = 'VehicleReservationCase/GetOneWayRentalReturnLocations',
  VehicleReservationGetDriversSkills = 'VehicleReservationCase/GetDriversSkills',
  VehicleReservationGetCrossBorder='VehicleReservationCase/GetCrossBorder',
  VehicleReservationReservationSaveAndConfirm='VehicleReservationCase/reservationSaveAndConfirm',
  VehicleReservationMyBooking='VehicleReservationCase/getVehicleReservationCasesByCustomerID',
  VehicleReservationTermsAndCondition='VehicleReservationCase/getTermsAndConditions',
  EvaluationSummary='Evaluation/getEvaluationSummary',
  EvaluationLogsMasters='Evaluation/getEvaluationLogsMasters',
  VehicleReservationCase='VehicleReservationCase/getVehicleReservationCase',
  GetOnlineCustomerCancellationReason='VehicleReservationCase/getOnlineCustomerCancellationReason',
  ReservationCancelConfirmed='VehicleReservationCase/reservationCancelConfirmed',
  CheckReservationCaseAvailability='VehicleReservationCase/checkReservationCaseAvailability',
  UpdateConfirmedRentalPeriod='VehicleReservationCase/reservationUpdateConfirmedRentalPeriod',
  CheckAvailabilityVehicleForExtensionPeriod='VehicleReservationCase/checkAvailabilityVehicleForExtensionPeriod',
  ReservationExtendContract='VehicleReservationCase/reservationExtendContract',
  ReservationUpdateConfirmedAdditionalService='VehicleReservationCase/reservationUpdateConfirmedAdditionalService',
  GetReservationCaseAdditionalService="VehicleReservationCase/getReservationCaseAdditionalService",
  UpdateCustomer="Customer/updateCustomer",
  CheckCustomerElegibility="Customer/checkCustomerElegibility",
  GetPayments="VehicleReservationCase/getPayments",
  GetCurrencies="VehicleReservationCase/getCurrencies",
  GetCustomerSummary="Customer/getCustomerSummary",
  GetVehicleReservationPolicy="VehicleReservationCase/getVehicleReservationPolicy",
  UpdateVehicleReservationSearchByAgency="VehicleReservationCase/updateVehicleReservationSearchByAgency",
  AddCustomerFavouriteReservation="Customer/addCustomerFavouriteReservation",
  GetCustomerFavouriteReservations="Customer/getCustomerFavouriteReservations",
  DeleteCustomerFavouriteReservation="Customer/deleteCustomerFavouriteReservation",
  ForgotPassword="Account/ForgotPassword",
  GetUserNotificationsResult="Notifications/getUserNotifications",
  UpdateNotificationStatus = "Notifications/updateNotificationStatus",
  DeleteAllNotifications = "Notifications/deleteAllNotifications",
  VehicleReservationAdvanceSearch="VehicleReservationCase/VehicleReservationAdvanceSearch",
  VehicleReservationSearch="VehicleReservationCase/VehicleReservationSearch",
  VehicleReservationSearchByAgency="VehicleReservationCase/VehicleReservationSearchByAgency",
  GetAdvanceSearchData="VehicleReservationCase/getAdvanceSearchData",
  GetModelsByMakeID="VehicleReservationCase/getModelsByMakeID",
  GetAvailablePaymentMethods="Payment/getAvailablePaymentMethods",
  ProceedPayment="Payment/proceedPayment",
  AddPublicReview="Evaluation/AddPublicReview",
  GetLocation="Customer/GetLocation",
  GetNationalities="Customer/getNationalities",
  UploadFile="Attachment/uploadFile",
  ImageHandler="Attachment/imageHandler",
  GetIdentityAttachemnt="Attachment/getIdentityAttachemnt",
  Handler_ImageHandler="Handler/ImageHandler",
  GetVehicleReservationsStatistic="Common/getVehicleReservationsStatistic",
  GetEvaluationClientsLogs="Common/getEvaluationClientsLogs",
  GetVehicleReservationsPopularDealsStatistics="Common/getVehicleReservationsPopularDealsStatistics",
  ReservationSettings="VehicleReservationCase/reservationSettings",
  GetLatestCampaigns="VehicleReservationCase/getLatestCampaigns",
  GetAccountStatment="VehicleReservationCase/getAccountStatment",
  AddCustomerPaymentMethods="Customer/addCustomerPaymentMethods",
  GetCustomerPaymentMethods="Customer/getCustomerPaymentMethods",
  DeleteCustomerPaymentMethods="Customer/deleteCustomerPaymentMethods",
  UpdateCustomerPaymentMethods="Customer/updateCustomerPaymentMethods",
  GetAgencies="Common/getAgencies",
  GetCancelationPolicy="VehicleReservationCase/getCancelationPolicy",
  GetVehicleGalleryByVehicleID="VehicleReservationCase/getVehicleGalleryByVehicleID",
  GetReceivedPayment="Payment/getReceivedPayment",
  GetMyContent="Common/getMyContent",
  GetMyTheme="Common/getMyTheme",
  ResetPassword="Account/ResetPassword",
  ChangePassword="Account/ChangePassword",
  GetWorkingHoursSetting="VehicleReservationCase/getWorkingHoursSetting",
  ContactUS="Common/contactUS",
  GetPayTabsForm = "Payment/getPayTabsForm",
  GetVehicleLocation = "Common/getVehicleLocation",
  GetFuelConsumption = "Common/getFuelConsumption",
  GetVehicleMileage = "Common/getVehicleMileage",
  GetFuelLevel = "Common/getFuelLevel",
  GetControlModuleVoltage = "Common/getControlModuleVoltage",
  GetVehicleEngineStatus = "Common/getVehicleEngineStatus",
  GetEngineCoolantTemperature = "Common/getEngineCoolantTemperature",
  GetSpeed = "Common/getSpeed",
  GetRpm = "Common/getRpm",
  GetLowBattery = "Common/getLowBattery",
  ChangeEmail = "Account/ChangeEmail",



}
